import { ROLE } from 'core/constants'
const Login = () => import('modules/auth/views/Login.vue')
const ForgotPassword = () => import('modules/auth/views/ForgotPassword.vue')
const ChangePassword = () => import('modules/auth/views/ChangePassword.vue')
const ResetPassword = () => import('modules/auth/views/ResetPassword.vue')
const Dashboard = () => import('modules/dashboard/views/index.vue')
const Application = () => import('modules/application/views/index.vue')
const Division = () => import('modules/division/views/DivisionHome.vue')
const Profile = () => import('modules/auth/views/Profile.vue')
const Project = () => import('modules/project/views/index.vue')
const User = () => import('modules/user/views/index.vue')
const CreateOrEditApp = () => import('modules/application/views/create-or-edit.vue')
const Error = () => import('modules/auth/views/error.vue')
const VerifyToken = () => import('modules/verify/views/index.vue')
const Tutorial = () => import('modules/tutorial/views/index.vue')
const Client = () => import('modules/client/views/index.vue')
const CreateOrEditClient = () => import('modules/client/views/create-or-edit.vue')

const routes = [
  {
    path: '/login',
    name: 'header.login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'label.forgotPassword',
    component: ForgotPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/reset-password',
    name: 'label.resetPassword',
    component: ResetPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/change-password',
    name: 'label.changePassword',
    component: ChangePassword,
    meta: {
      hideInMenu: true,
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
    },
  },
  {
    path: '/profile',
    name: 'label.yourProfile',
    component: Profile,
    meta: {
      hideInMenu: true,
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
    },
  },
  {
    path: '/',
    name: 'header.dashboard',
    component: Dashboard,
    meta: {
      icon: 'HomeIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
    },
  },
  {
    path: '/suite',
    name: 'header.division',
    component: Division,
    meta: {
      icon: 'OfficeBuildingIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN],
      abilities: [{ action: 'index', name: 'division' }],
    },
  },
  {
    path: '/project',
    name: 'header.project',
    component: Project,
    meta: {
      icon: 'ClipboardIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN],
      abilities: [{ action: 'index', name: 'project' }],
    },
  },
  {
    path: '/user',
    name: 'header.user',
    component: User,
    meta: {
      icon: 'UserIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN],
      abilities: [{ action: 'index', name: 'user' }],
    },
  },
  {
    path: '/application',
    name: 'header.application',
    component: Application,
    meta: {
      icon: 'FolderIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
      abilities: [{ action: 'index', name: 'application' }],
    },
  },
  {
    path: '/client',
    name: 'header.client',
    component: Client,
    meta: {
      icon: 'IdentificationIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
      abilities: [{ action: 'index', name: 'client' }],
    },
  },
  {
    path: '/client/create',
    name: 'header.createClient',
    component: CreateOrEditClient,
    meta: {
      hideInMenu: true,
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
      abilities: [{ action: 'index', name: 'client' }],
    },
  },
  {
    path: '/client/edit/:id/:divisionId',
    name: 'header.editClient',
    component: CreateOrEditClient,
    meta: {
      hideInMenu: true,
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
      abilities: [{ action: 'index', name: 'client' }],
    },
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
  },
  {
    path: '/verify',
    name: 'header.verifyToken',
    component: VerifyToken,
    meta: {
      icon: 'CheckCircleIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
    },
  },
  {
    path: '/tutorial',
    name: 'header.tutorial',
    component: Tutorial,
    meta: {
      icon: 'DocumentTextIcon',
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
    },
  },
  {
    path: '/application/create',
    name: 'header.createApp',
    component: CreateOrEditApp,
    meta: {
      hideInMenu: true,
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
      abilities: [{ action: 'index', name: 'application' }],
    },
  },
  {
    path: '/application/edit/:id/:divisionId',
    name: 'header.editApp',
    component: CreateOrEditApp,
    meta: {
      hideInMenu: true,
      requiresAuth: true,
      roles: [ROLE.SUPER_ADMIN, ROLE.DIVISION_ADMIN, ROLE.SYSTEM_USER],
      abilities: [{ action: 'index', name: 'application' }],
    },
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
  },
]

export default routes
